export default "__VITE_ASSET__B4_vSNWa__"